<template>
  <div>
    <useTable
      :searchForm="searchForm"
      :httprequest="httprequest"
      ref="useTable"
      :headerList="headerData"
    ></useTable>

    <el-dialog
      title="提示"
      :visible.sync="centerDialogVisible"
      width="500px"
      center
    >
      <span>确认删除{{ deletInfo.name }}吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleConfrimClick">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import useTable from "@/components/useTable/useTable.vue";
import { mapActions } from "vuex";
export default {
  data() {
    const statusList = [
      {
        label: "全部",
        value: "",
      },
      {
        label: "上架",
        value: 1,
      },
      {
        label: "下架",
        value: 2,
      },
    ];
    const sentType = [
      {
        label: "全部",
        value: ""
      },
      {
        label: "直播间",
        value: 1
      },
      {
        label: "接口发放",
        value: 2
      },
      {
        label: "平台活动发放",
        value: 3
      },
      {
        label: "Im场景发放",
        value: 4
      },
    ];
    return {
      classNames: "coupon",
      centerDialogVisible:false,
      deletInfo:{},
      headerData: [
        {
          props: {
            prop: "id",
            label: "ID",
            width: 50,
          },
        },
        {
          props: {
            prop: "name",
            label: "名称",
            width: 180,
            "show-overflow-tooltip": true,
          },
        },
        {
          props: {
            prop: "consume_desc",
            label: "优惠内容",
            width: 160,
            "show-overflow-tooltip": true,
          },
        },
        {
          props: {
            prop: "",
            label: "已使用/已领取/总数",
            width: 150,
          },
          render: (h, scope) => {
            return (
              <div style="display:flex;">
                <span>{scope.row.use_count}/</span>
                <span>{scope.row.receive_count}/</span>
                <span>{scope.row.total_count}</span>
              </div>
            );
          },
        },
        {
          props: {
            prop: "status_desc",
            label: "上架状态",
            width: 100,
          },
        },
        {
          props: {
            prop: "getscene_desc",
            label: "发放场景",
            width: 100,
          },
        },
        {
          props: {
            prop: "use_range",
            label: "使用范围",
            width: 100,
          },
        },
        {
          props: {
            prop: "",
            label: "操作",
            width: 160,
          },
          render: (h, scope) => {
            return (
              <div class="button_warp">
                <div
                  class="line_button"
                  onClick={this.handleEdits.bind(
                    this,
                    scope.row.id,
                  )}
                >
                  编辑
                </div>
                <div
                  class="line_button"
                  onClick={this.handleDeletes.bind(
                    this,
                    scope.row
                  )}
                >
                  删除
                </div>
                <div
                  class="line_button"
                  onClick={this.handleRecord.bind(
                    this,
                    scope.row
                  )}
                >
                  领取记录
                </div>
              </div>
            );
          },
        },
      ],
      searchParams: {
        limit: 10,
        page: 1,
      },
      searchForm: [
        {
          Component: "el-button",
          span: 3,
          componentProps: {
            type: "primary",
          },
          renderHTML: () => {
            return "添加优惠券";
          },
          on: {
            click: this.addCoupon,
          },
        },
        {
          defaultValue: "",
          label: "状态",
          Component: "el-select",
          prop: "status",
          span: 7,
          componentProps: {
            placeholder: "请选择状态",
          },
          on: {
            change: (value) => {
              this.$nextTick(() => {
                this.$refs.useTable.getRequestRes("firstPage");
              });
            },
          },
          childSlot: statusList.map((item) => {
            return {
              Component: "el-option",
              componentProps: {
                label: item.label,
                value: item.value,
                key: item.value,
              },
            };
          }),
        },
        {
          defaultValue: "",
          label: "发放场景",
          Component: "el-select",
          prop: "getscene",
          span: 7,
          componentProps: {
            placeholder: "请选择",
          },
          on: {
            change: (value) => {
              this.$nextTick(() => {
                this.$refs.useTable.getRequestRes("firstPage");
              });
            },
          },
          childSlot: sentType.map((item) => {
            return {
              Component: "el-option",
              componentProps: {
                label: item.label,
                value: item.value,
                key: item.value,
              },
            };
          }),
        },
        {
          Component: "el-input",
          prop: "name",
          defaultValue: "",
          span: 5,
          label: "",
          componentProps: {
            placeholder: "请输入优惠券名称",
          },
        },
        {
          Component: "el-button",
          span: 2,
          componentProps: {
            type: "primary",
          },
          renderHTML: () => {
            return "查询";
          },
          on: {
            click: () => {
              this.$refs.useTable.getRequestRes("firstPage");
            },
          },
        },
      ],
    };
  },
  components: {
    useTable
  },
  methods: {
    ...mapActions('coupon',['couponList','couponDelete']),

    async httprequest(params) {
      this.searchParams = params;
      let res = await this.couponList(params);
       console.log(res,'res0-0-0-00-')
      let keys = {
        data: res.list,
        total: res.count,
      };
      return keys;
    },
    addCoupon(){
        this.$router.push(this.staticPath + "addCoupon");
    },
    handleEdits(id) {
      this.$router.push({
        path: this.staticPath + "editCoupon/" + id,
      });
    },
    handleDeletes(val){
      this.centerDialogVisible = true
      this.deletInfo = val
    },
    async handleConfrimClick(){
      await this.couponDelete({id:this.deletInfo.id})
      this.$message({
        type: "success",
        message: "删除成功",
      });
      this.centerDialogVisible = false
      this.$refs.useTable.getRequestRes("firstPage");
    },
    handleRecord(val){
      console.log('coupon/record',this.staticPath + "coupon/record/" + val.merchant_meta_no)
      this.$router.push({
        path: this.staticPath + "coupon/record/" + val.merchant_meta_no,
      });
    }
  }
};
</script>

<style>
</style>